import React from 'react';
import { API_URLS } from '../../config/Constants';
import { SharedContent } from '../../services/shareService';
import SharedTournamentPlayersLeaderboard from './SharedTournamentPlayersLeaderboard';

interface SharedPlayersLeaderboardProps {
  shareData: SharedContent;
}

const SharedPlayersLeaderboard: React.FC<SharedPlayersLeaderboardProps> = ({ shareData }) => {
  return (
    <SharedTournamentPlayersLeaderboard
      shareData={shareData}
      fetchPath={`${API_URLS.BASE_URL}/share/leaderboard/players/${shareData.shareId}`}
      loadingLabel="Loading leaderboard..."
      defaultTitle="Players Leaderboard"
      loadErrorMessage="Failed to load leaderboard"
    />
  );
};

export default SharedPlayersLeaderboard;
